let supportsIntersectionObserver = false;

if ('IntersectionObserver' in window) {
  supportsIntersectionObserver = true;
}

export default supportsIntersectionObserver;